export function isDirectParent(
  parentFullPath: string,
  childFullPath: string
): boolean {
  const childRelPaths = childFullPath.split('/');
  const parentRelPaths = parentFullPath.split('/');
  return (
    parentRelPaths.length === childRelPaths.length - 1 &&
    parentRelPaths.every((parentRelPath) =>
      childRelPaths.includes(parentRelPath)
    )
  );
}
